export default __webpack_public_path__ + "static/media/flu.27da658e.webp";